export default __webpack_public_path__ + "static/media/Dolly_Zoom.80af3ecf.gif";